



























































































































































































































import {Component, Ref, Vue} from 'vue-property-decorator'
import {Container} from "typescript-ioc";
import {PqForm} from "biz-ts/src/api/Paging";
import PaginationTable from "@/component/Table/pagination-table.vue";
import RefreshButton from "@/component/Button/refresh-button.vue";
import CreateDialog from "@/component/Crud/create-dialog.vue";
import EditDialog from "@/component/Crud/edit-dialog.vue";
import DeleteDialog from "@/component/Crud/delete-dialog.vue";
import ThingPropertyMappingApi, {
  TpropMappingCreateForm,
  TpropMappingEditForm,
} from "@/module/thing/ThingPropertyMappingApi";
import ThingPropertyMapping from "@/model/ThingPropertyMapping";
import {Form} from "element-ui";
import Product from "@/model/Product";
import ProductApi from "@/module/device/ProductApi";
import CategoryApi from "@/module/device/CategoryApi";
import Category from "@/model/Category";
import IdColumn from "@/component/Table/id-column.vue";

@Component({
  components: {
    IdColumn,
    PaginationTable,
    RefreshButton,
    CreateDialog,
    EditDialog,
    DeleteDialog,
  },
})
export default class TpropertyMappingView extends Vue {

  private tpropMappingApi = Container.get(ThingPropertyMappingApi)

  @Ref()
  private ptable!: PaginationTable

  private pqForm = new PqForm()

  private getPaging() {
    return this.tpropMappingApi.paging(this.pqForm)
  }

  private refresh() {
    this.ptable?.refresh()
  }

  private rules =
      {
        identifier: [
          {required: true, message: '请输入标识符', trigger: ['change', 'blur']},
        ],
      }

  @Ref()
  private addDialog!: CreateDialog

  private addForm = new TpropMappingCreateForm()

  @Ref()
  private addElForm!: Form

  private categoryApi = Container.get(CategoryApi)

  private productApi = Container.get(ProductApi)

  private async beforeOpenAddDialog() {
    this.addElForm?.resetFields()
    this.addForm.init()
    await Promise.all([
      this.getCategories(),
      this.getProducts(),
    ])
  }

  private products: Array<Product> = []

  private async getProducts() {
    this.products = await this.productApi.list()
  }

  private categories: Array<Category> = []

  private async getCategories() {
    this.categories = await this.categoryApi.list()
  }

  private async addMapping() {
    const valid = await this.addElForm.validate()
    if (valid)
      await this.tpropMappingApi.create(this.addForm)
  }

  private tpmappging = new ThingPropertyMapping()

  @Ref()
  private editDialog!: EditDialog

  private editForm = new TpropMappingEditForm()

  @Ref()
  private editElForm!: Form

  private handleEditClick(tpmappging: ThingPropertyMapping) {
    this.tpmappging = tpmappging
    this.editDialog.open()
  }

  private async beforeOpenEdiDialog() {
    this.editElForm?.resetFields()
    this.editForm.id = this.tpmappging.id
    this.editForm.identifier = this.tpmappging.identifier
    this.editForm.categoryId = this.tpmappging.categoryId
    this.editForm.productId = this.tpmappging.productId
    this.editForm.tmallProp = this.tpmappging.tmallProp
    await Promise.all([
      this.getCategories(),
      this.getProducts(),
    ])
  }

  private async editMapping() {
    const valid = await this.editElForm.validate()
    if (valid)
      await this.tpropMappingApi.edit(this.editForm)
  }

  @Ref()
  private deleteDialog!: DeleteDialog

  private async handleDeleteClick(tpmappging: ThingPropertyMapping) {
    this.tpmappging = tpmappging
    this.deleteDialog.open()
  }

  private async deleteMapping() {
    await this.tpropMappingApi.delete(this.tpmappging.id)
  }
}
